export default __webpack_public_path__ + "static/media/5083.77ce8aea.png";